import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { getAdminUsersApi, setFilteredChips } from '../../../redux/features/adminUserSlice';
import { userRoleConstants } from '../../../utils/constants';

const FilterUserModal = ({ currentSize, filteredChips }) => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  const [roleId, setRoleId] = useState('');
  const [userName, setUserName] = useState('');
  const [onboardingDate, setOnboardingDate] = useState('');
  const [submitOnboardingDate, setSubmitOnboardingDate] = useState('');
  const [status, setStatus] = useState('');

  useEffect(() => {
    if (show) {
      const chipsMap = Object.fromEntries(filteredChips ?? []);
      setRoleId(chipsMap.role_id?.value ?? '');
      setUserName(chipsMap.name ?? '');
      setOnboardingDate(chipsMap.onboarding_date?.label ?? '');
      setSubmitOnboardingDate(chipsMap.onboarding_date?.value ?? '');
      setStatus(chipsMap.is_active?.value ?? '');
    }
  }, [show, filteredChips]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleEventRequestDate = (event, picker) => {
    picker.element.val(picker.startDate.format('DD-MM-YYYY') + ' - ' + picker.endDate.format('DD-MM-YYYY'));
    setOnboardingDate(picker.startDate.format('DD-MM-YYYY') + ' - ' + picker.endDate.format('DD-MM-YYYY'));
    setSubmitOnboardingDate(picker.startDate.format('YYYY-MM-DD') + ' - ' + picker.endDate.format('YYYY-MM-DD'));
  };

  const handleCancelRequestDate = (event, picker) => {
    picker.element.val('');
    setOnboardingDate('');
    setSubmitOnboardingDate('');
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    const chipsEntries = [];
    const filterData = {};

    if (roleId) {
      const roleLabel = Object.keys(userRoleConstants).find(key => userRoleConstants[key] === parseInt(roleId))?.replace('_ID', '').replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase()) || 'Role';
      chipsEntries.push(['role_id', { label: roleLabel, value: roleId }]);
      filterData.role_id = roleId;
    }
    if (userName) {
      chipsEntries.push(['name', userName]);
      filterData.name = userName;
    }
    if (submitOnboardingDate) {
      chipsEntries.push(['onboarding_date', { label: onboardingDate, value: submitOnboardingDate }]);
      filterData.onboarding_date = submitOnboardingDate;
    }
    if (status !== '') {
      const statusLabel = status === '1' ? 'Active' : 'Inactive';
      chipsEntries.push(['is_active', { label: statusLabel, value: status }]);
      filterData.is_active = status;
    }

    dispatch(setFilteredChips(chipsEntries));
    dispatch(getAdminUsersApi({ filteredData: filterData, page: 1, size: currentSize ?? 10 }));
    setShow(false);
  };

  const handleReset = () => {
    setRoleId('');
    setUserName('');
    setOnboardingDate('');
    setSubmitOnboardingDate('');
    setStatus('');
    dispatch(setFilteredChips([]));
    dispatch(getAdminUsersApi({ filteredData: {}, page: 1, size: currentSize ?? 10 }));
    setShow(false);
  };

  return (
    <>
      <button type="button" className="btn btn-sm btn-primary rounded-1 btn-smwaves-effect waves-light me-1 py-1 px-2" onClick={handleShow}>
        <i className="ti ti-filter"></i>
      </button>

      <Modal show={show} size="md" centered enforceFocus={false} onHide={handleClose} backdrop="static">
        <div className="modal-simple modal-edit-user">
          <div className="modal-content p-3 p-md-3">
            <Modal.Body className="p-2">
              <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
              <div className="text-left mb-0">
                <h3 className="mb-3">Filter</h3>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6">
                    <label className="form-label">Role</label>
                    <select
                      className="form-control form-select mb-3"
                      name="roleId"
                      value={roleId}
                      onChange={(e) => setRoleId(e.target.value)}
                    >
                      <option value="">...</option>
                      <option value={userRoleConstants.MANAGER_ID}>Manager</option>
                      <option value={userRoleConstants.SUPERVISOR_ID}>Supervisor</option>
                      <option value={userRoleConstants.ACCOUNTANT_ID}>Accountant</option>
                      <option value={userRoleConstants.PROCUREMENT_ID}>Procurement</option>
                    </select>
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="userName"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label">Onboarding Date</label>
                     <DateRangePicker
                      key={onboardingDate}
                      initialSettings={{
                        autoUpdateInput: false,
                        locale: { cancelLabel: 'Clear', format: 'DD-MM-YYYY' },
                        showDropdowns: true,
                        drops: 'up'
                      }}
                      onApply={handleEventRequestDate}
                      onCancel={handleCancelRequestDate}
                    >
                      <input
                        type="text"
                        className="form-control mb-3"
                        placeholder="Select Date"
                        defaultValue={onboardingDate}
                        autoComplete="off"
                        readOnly
                      />
                    </DateRangePicker>
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label">Status</label>
                    <select
                      className="form-control form-select mb-3"
                      name="status"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="">...</option>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 text-center mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary rounded-pill me-sm-3 me-1 waves-effect waves-light show-filter"
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-label-secondary rounded-pill btn-reset waves-effect"
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </form>
            </Modal.Body>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FilterUserModal;